import { activityHistoryCollectionsSlice } from "../slice";

export const { removeActivityHistoryItem } = activityHistoryCollectionsSlice.actions;